<template>
    <span class="badge badge-purple mr-1">
        <i class="fas fa-filter mr-1"></i>
        {{ content }}
        <i class="fas fa-window-close ml-1 cursor-pointer" @click="remove"></i>
    </span>

</template>

<script>
    export default {
        props: {
            display: String,
            index: null,
            name: String,
            value: null,
        },

        computed: {
            content() {
                return this.value;
            },
        },

        methods: {
            remove() {
                this.$emit('remove', {
                    name: this.name,
                    index: this.index,
                });
            },
        },
    }
</script>
